/* eslint-disable max-len */
import React, { FC } from "react";

/**
 * A functional React component that renders a Arrow/Carrot SVG icon UI element.
 */
export const IconArrow: FC<{ className?: string }> = ({ className }) => (
    <svg className={className} width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={true} aria-labelledby="icon-arrow">
        <g clipPath="url(#a)">
            <path fill="#333" stroke="#303237" strokeWidth=".784" d="m4.762 5.991-.274.267-.273-.267-2.86-2.789-.312.312L4.488 6.96l3.446-3.446-.312-.312-2.86 2.789Z" />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M.488.93h8v8h-8z" />
            </clipPath>
        </defs>
    </svg>
);
